import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { processLogin } from "../../helper/commonHelper";
import { setUserData, ssoAuth } from "../../utils/ApiHandler";
import { ROUTES_PATH } from "../../utils/EndPoints";

const SSOCallback = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [path, setPath] = useState(window.location.href);

  useEffect(() => {
    if (path.includes("code")) {
      const searchParams = new URLSearchParams(window.location.search);
      const code = searchParams.get("code");
      if (!code) {
        console.error("Code not found in URL");
        return;
      }
      const credentials = JSON.parse(localStorage.getItem("sso_credentials"));
      ssoAuth({
        code,
        state: credentials?.state,
        email: credentials?.email,
      })
        .then((res) => {
          const user = res.data.data;
          setUserData(user);
          const selected_business_unit = JSON.parse(
            localStorage.getItem("selected_business_unit")
          );
          processLogin(res, dispatch, selected_business_unit);
        })
        .catch((err) => {
          navigate(ROUTES_PATH.SCAI)
          console.error("Backend Auth Error", err);
        });
    }
  }, [path]);

  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Typography>Processing Microsoft SSO Login...</Typography>
    </Box>
  );
};

export default SSOCallback;
